<div class="nf-panel cov-dialog">
    <div class="nf-panel__header nf-panel__header--action">
        <div class="nf-panel__heading">
            <div class="nf-panel__title">Coverage</div>
            <div class="nf-panel__subtitle">
                @if (trafficPercent !== null) { {{ trafficPercent }}% of selected traffic covered }
                @else { Coverage of the selected traffic }
                @if (windowLabel) { <span class="cov-window">&middot; {{ windowLabel }}</span> }
            </div>
        </div>
        <button type="button" class="cov-close" aria-label="Close" (click)="close()">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
        </button>
    </div>

    <ng-template #icCovered><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="2.2"><circle cx="12" cy="12" r="9" /><path d="M8 12.4l2.6 2.6L16 9" stroke-linecap="round"
            stroke-linejoin="round" /></svg></ng-template>
    <ng-template #icPartial><svg viewBox="0 0 24 24" width="14" height="14"><circle cx="12" cy="12" r="9" fill="none"
            stroke="currentColor" stroke-width="2.2" /><path d="M12 3.2a8.8 8.8 0 0 0 0 17.6z" fill="currentColor" />
        </svg></ng-template>
    <ng-template #icUncovered><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="2.2"><circle cx="12" cy="12" r="9" stroke-dasharray="1.6 3.2" stroke-linecap="round" />
        </svg></ng-template>

    <div class="cov-toolbar">
        <div class="cov-pills" role="tablist" aria-label="Coverage filter">
            <button type="button" class="cov-pill" role="tab" [attr.aria-selected]="filter === 'all'"
                [class.cov-pill--on]="filter === 'all'" (click)="setFilter('all')">
                <span class="cov-pill__label">All</span><span class="cov-pill__count">{{ counts.total }}</span>
            </button>
            <button type="button" class="cov-pill" role="tab" [attr.aria-selected]="filter === 'covered'"
                [class.cov-pill--on]="filter === 'covered'" (click)="setFilter('covered')"
                [disabled]="!counts.covered">
                <i class="cov-ic cov-ic--covered"><ng-container *ngTemplateOutlet="icCovered"></ng-container></i>
                <span class="cov-pill__label">Covered</span><span class="cov-pill__count">{{ counts.covered }}</span>
            </button>
            <button type="button" class="cov-pill" role="tab" [attr.aria-selected]="filter === 'partial'"
                [class.cov-pill--on]="filter === 'partial'" (click)="setFilter('partial')"
                [disabled]="!counts.partial">
                <i class="cov-ic cov-ic--partial"><ng-container *ngTemplateOutlet="icPartial"></ng-container></i>
                <span class="cov-pill__label">Partial</span><span class="cov-pill__count">{{ counts.partial }}</span>
            </button>
            <button type="button" class="cov-pill" role="tab" [attr.aria-selected]="filter === 'uncovered'"
                [class.cov-pill--on]="filter === 'uncovered'" (click)="setFilter('uncovered')"
                [disabled]="!counts.uncovered">
                <i class="cov-ic cov-ic--uncovered"><ng-container *ngTemplateOutlet="icUncovered"></ng-container></i>
                <span class="cov-pill__label">Uncovered</span><span class="cov-pill__count">{{ counts.uncovered }}</span>
            </button>
        </div>

        @if (hasWindow) {
        <div class="cov-seg" role="tablist" aria-label="Graph scope">
            <button type="button" role="tab" [attr.aria-selected]="mode === 'selected'"
                [class.cov-on]="mode === 'selected'" (click)="setMode('selected')">Selected only</button>
            <button type="button" role="tab" [attr.aria-selected]="mode === 'full'"
                [class.cov-on]="mode === 'full'" (click)="setMode('full')">Full graph</button>
        </div>
        }

        <div class="cov-legend">
            <span class="cov-key"><i class="sw sw-covered"></i>
                <i class="cov-ic cov-ic--covered"><ng-container *ngTemplateOutlet="icCovered"></ng-container></i>Covered</span>
            <span class="cov-key"><i class="sw sw-partial"></i>
                <i class="cov-ic cov-ic--partial"><ng-container *ngTemplateOutlet="icPartial"></ng-container></i>Partial</span>
            <span class="cov-key"><i class="sw sw-uncovered"></i>
                <i class="cov-ic cov-ic--uncovered"><ng-container *ngTemplateOutlet="icUncovered"></ng-container></i>Uncovered</span>
            @if (mode === 'full') {
            <span class="cov-key cov-key--dim"><i class="sw sw-notsel"></i>Not selected</span>
            }
        </div>
    </div>

    <div class="nf-panel__body cov-body">
        @if (degraded) {
        <div class="cov-note">Showing a graph built from the selection only. Open this from Traffic Analysis
            with its time window to see the full traffic context.</div>
        }
        @if (error) {
        <div class="cov-note cov-note--warn">{{ error }}</div>
        }

        @if (loading) {
        <div class="cov-state">Loading traffic&hellip;</div>
        } @else if (isEmpty) {
        <div class="cov-state">No traffic to show for this selection.</div>
        } @else {
        <div class="cov-stage">
            <div class="cov-chart">
                <app-flow-map-chart [nodes]="nodes" [links]="links" [headers]="headers"
                    [highlightNodeIds]="highlightNodeIds" [highlightLinkIds]="highlightLinkIds"
                    ariaLabel="Service coverage flow map"
                    (nodeHover)="onNodeHover($event)"
                    (nodeClick)="onNodeClick($event)"
                    (linkClick)="onLinkClick($event)"
                    (nodeToggle)="onNodeToggle($event)"
                    (backgroundClick)="onBackground()"></app-flow-map-chart>
            </div>
            @if (detail) {
            <app-detail-drawer [eyebrow]="detail.eyebrow" [title]="detail.title" (closed)="closeDetail()">
                <app-coverage-detail-content [explain]="detail.explain"
                    (rowHover)="onDetailRowHover($event)"
                    (toggleInclude)="onDetailIncludeToggle($event)"></app-coverage-detail-content>
            </app-detail-drawer>
            }
        </div>
        }
    </div>
</div>
